import { render, staticRenderFns } from "./roleAuthority_user_app.vue?vue&type=template&id=08d7065e&scoped=true"
import script from "./roleAuthority_user_app.vue?vue&type=script&lang=js"
export * from "./roleAuthority_user_app.vue?vue&type=script&lang=js"
import style0 from "./roleAuthority_user_app.vue?vue&type=style&index=0&id=08d7065e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d7065e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d7065e')) {
      api.createRecord('08d7065e', component.options)
    } else {
      api.reload('08d7065e', component.options)
    }
    module.hot.accept("./roleAuthority_user_app.vue?vue&type=template&id=08d7065e&scoped=true", function () {
      api.rerender('08d7065e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authorityManagement_user_app/roleAuthority_user_app.vue"
export default component.exports